import 'es6-shim';
import * as React from 'react';
import { render } from 'react-dom';
import AppRouter from './containers/AppRouter';
import './styles/main.less';

document.addEventListener('DOMContentLoaded', () => {
	const rootElement = document.getElementById('react-root');

	render(<AppRouter/>, rootElement);
});
